export const validateRepertorio = (data) => {
  let issues = [];
  if(!data["tipo"]) issues.push("É necessario specificare il tipo di inventario");
  if(!data["codice"]) issues.push("É necessario specificare il codice di inventario");
  return issues;
}
